import functions from "@/utils/functions";
import "ant-design-vue/dist/antd.less";
import Antd from "ant-design-vue/es";
import VueRouter from "vue-router";
import router from "./router";
import i18n from "./locales";
import App from "./App.vue";
import store from "./store";
import Vue from "vue";

Vue.config.productionTip = false;
Vue.prototype.$functions = functions;
Vue.use(VueRouter);
Vue.use(Antd);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
